import { AppConfigService } from './../app-config.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ChangePasswordService {
  private readonly config: any;

  constructor(private readonly http: HttpClient, private readonly configService: AppConfigService) {
    this.config = configService.config;
  }

  changePassword(data: any) {
    return this.http.post(`${this.config?.apiUrl}user/changePassword`, data);
  }
}
